var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box 1",
    clipPath: "url(#clip0_1109_350)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.2091 -0.81906L2.13282 11.2868C1.81837 11.4386 1.61865 11.7569 1.61865 12.106V41.8941C1.61865 42.2432 1.81848 42.5615 2.13282 42.7133L27.2091 54.8191C27.7089 55.0604 28.2914 55.0604 28.7911 54.8191L53.8674 42.7133C54.1819 42.5615 54.3816 42.2432 54.3816 41.8941V12.106C54.3816 11.7569 54.1818 11.4386 53.8674 11.2868L28.7911 -0.81906C28.2914 -1.06023 27.7089 -1.06023 27.2091 -0.81906Z",
    fill: "#FFE17D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.76992 11.608C1.67432 11.7536 1.61865 11.925 1.61865 12.106V41.8941C1.61865 42.2432 1.81848 42.5615 2.13282 42.7133L27.2091 54.819C27.4589 54.9397 27.7295 54.9999 28.0001 54.9999V24.2709L1.76992 11.608Z",
    fill: "#FFC350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M54.2302 11.608C54.3258 11.7536 54.3815 11.925 54.3815 12.106V41.8941C54.3815 42.2432 54.1816 42.5615 53.8673 42.7133L28.791 54.819C28.5412 54.9397 28.2706 55 28 55V24.2709L54.2302 11.608Z",
    fill: "#FFD164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.12278 40.3063C8.99044 40.3063 8.85536 40.2769 8.72838 40.2157L4.85683 38.3466C4.4038 38.1281 4.21458 37.5844 4.43311 37.1322C4.65077 36.68 5.19622 36.4917 5.6475 36.7085L9.51905 38.5777C9.97208 38.7962 10.1613 39.3399 9.94277 39.7921C9.78647 40.117 9.4613 40.3063 9.12278 40.3063Z",
    fill: "#FFE17D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.6861 37.9868C12.5537 37.9868 12.4187 37.9574 12.2917 37.8962L4.86205 34.3098C4.4099 34.0913 4.2198 33.5475 4.43833 33.0954C4.65599 32.6441 5.20232 32.4549 5.65272 32.6717L13.0822 36.2581C13.5344 36.4766 13.7245 37.0203 13.506 37.4725C13.3498 37.7974 13.0246 37.9868 12.6861 37.9868Z",
    fill: "#FFF6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M45.3412 15.8846L19.0188 3.16833L12.0801 6.53162L38.4615 19.2676L45.3412 15.8846Z",
    fill: "#A4C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M38.4614 19.2675V29.1339C38.4614 29.4692 38.812 29.6893 39.1141 29.5435L44.8269 26.7856C45.1414 26.6338 45.3411 26.3155 45.3411 25.9664V15.8846L38.4614 19.2675Z",
    fill: "#7DB1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1109_350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 59.1746,
    fill: "white",
    transform: "translate(0 0.53064)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.71babc7924699b23673f8393bddccd57.svg";
export { ForwardRef as ReactComponent };